@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.exclamation-triangle-solid {
  height: 30px;
  width: 30px;
  fill: @error-badge-tooltip--exclamation-triangle--fill-color;
  transform: scale(0.5);
}

.icon-only,
.text,
.text-with-background {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px 0 5px;
}

.text-with-background {
  background-color: @error-badge-tooltip--text--background-color;
  border-radius: 5px;
}

.error-message-text {
  color: @error-badge-tooltip--message--text-color;
  font-weight: @bold;
  font-size: 0.9em;
}

.unstyled-error-item,
.styled-error-item {
  width: max-content;
  max-width: 280px;

  li {
    display: block;
    word-wrap: break-word;
  }
}

.styled-error-item {
  li {
    list-style-type: circle;
  }
}

.unstyled-error-item {
  li {
    list-style-type: none;
  }
}

.tooltip-content {
  display: flex;
  flex-direction: column;
  width: fit-content;
  max-width: 300px;
}
